import Vue from 'vue';
import 'vuetify/dist/vuetify.min.css';
import Vuetify from 'vuetify';
import colors from 'vuetify/lib/util/colors';
import { VuetifyPreset } from 'vuetify/types/services/presets';
import Lib from 'vuetify/lib';

Vue.use(Vuetify);


Lib.config.silent = !['local'].find(env => process.env.NODE_ENV === env);
const options: VuetifyPreset = { //https://vuetifyjs.com/en/features/presets/#default-preset
  breakpoint: {
    mobileBreakpoint: 'xs',
    scrollBarWidth: 16,
    thresholds: {
      xs: 600,
      sm: 960,
      md: 1280,
      lg: 1920,
    }
  },
  icons: {
    iconfont: 'mdi',
    values: { }
  },
  lang: {
    t: () => '',
    locales: {},
    current: 'en'
  },
  rtl: false,
  theme: {
    dark: window?.matchMedia('(prefers-color-scheme: dark)')?.matches || false,
    default: 'light',
    disable: false,
    options: {
      customProperties: true,
    },
    themes: {
      light: {
        primary: colors.blue, 
        secondary: colors.lightBlue,
        accent: colors.cyan,
        error: colors.red.base,
        info: colors.orange,
        success: colors.green,
        warning: colors.yellow.darken3,
        background: '#fafafa',
        paper: '#fff',
        hover: '#f6f6f6',
        gmk: '#ed174c',
        gmk1: '#cd0e13'
      },
      dark: {
        primary: colors.blue, 
        secondary: colors.lightBlue,
        accent: colors.cyan,
        error: colors.red.base,
        info: colors.orange,
        success: colors.green,
        warning: colors.yellow.darken3,
        background: '#121212',
        paper: '#1f1f1f',
        hover: '#303030',
        gmk: '#ed174c',
        gmk1: '#cd0e13',
      },
    }
  }
};
const vuetify = new Vuetify(options);
export default vuetify;